<template>
  <div :class="classes">
    <label class="exp-checkbox-label">
      <input
        :name="`ml-checkbox-${id}`"
        type="checkbox"
        :disabled="disabled"
        v-model="internalValue"
        @click="onClick"
      />
      <span class="exp-checkbox-custom"></span>
      <span v-if="text || title" class="exp-checkbox-text">{{ text || title }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'MemlistCheckbox',
  props: {
    id: {
      type: String,
      default: 'none'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null
    },
    meta: {
      type: Object,
      default: null
    }
  },
  emits: ['click','input','change'],
  data() {
    return {
      internalValue: this.value,
    }
  },
  watch: {
    // update internalValue when parent prop changes
    value(newVal) {
      this.internalValue = newVal;
    },
    // emit change to parent when internal value changes
    internalValue(newVal) {
      this.$emit('input', newVal, this.meta);
      this.$emit('change', newVal, this.meta);
    }
  },
  methods: {
    onClick(event) {
      // This callback will be triggered when the checkbox is clicked.
      // You can perform any additional logic here.
      this.$nextTick(()=>{
        setTimeout(()=>{
          console.log('internalValue', this.internalValue)
          this.$emit('click', event);
        }, 100);
        
      });
    },
  },
  computed: {
    classes() {
      if (this.disabled) {
        return ['exp-checkbox-wrapper', 'ml-checkbox', 'disabled'];
      }

      return ['exp-checkbox-wrapper', 'ml-checkbox'];
    }
  }
};
</script>

<style scoped>
.exp-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.exp-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.exp-checkbox-label input {
  opacity: 0;
  width: 0;
  height: 0;
}

.exp-checkbox-custom {
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 2px solid #0085eb;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.2s, border-color 0.2s;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom {
  background-color: #0085eb;
  border-color: #0085eb;
}

.exp-checkbox-custom::after {
  content: "";
  position: absolute;
  display: none;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom::after {
  display: block;
}

.exp-checkbox-custom::after {
  left: 6px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.exp-checkbox-text {
  margin-left: 12px;
  font-size: 13px;
}

.exp-checkbox-wrapper.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.exp-checkbox-wrapper.disabled .exp-checkbox-label {
  cursor: not-allowed;
}

.exp-checkbox-wrapper.disabled .exp-checkbox-custom {
  background-color: #f0f0f0;
  border-color: #ccc;
}

.exp-checkbox-wrapper.disabled input:checked ~ .exp-checkbox-custom {
  background-color: #ccc;
  border-color: #ccc;
}

.exp-checkbox-wrapper.disabled input:checked ~ .exp-checkbox-custom::after {
  border-color: white;
}

</style>
